import axios from 'axios'

const state = {
    setOrder: null,
    setOrders: null,
    setAddresses: null,
}

const getters = {
    setOrder (state) {
        return state.setOrder
    },
    setOrders (state) {
        return state.setOrders
    },
    setAddresses (state) {
        return state.setAddresses
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {      
    async fetchOrderAction({ commit }, orderObj) { 
        commit('SET_ORDER', null)
        let response = await axios.get(`/customer-orders/order-number/${orderObj.orderNumber}`)
        if(!response.data.error){
            commit('SET_ORDER', response.data.result)
        }
        return response.data
    },
    
    async fetchOrdersAction({ commit }, ordersObj) { 
        commit('SET_ORDERS', null)
        let response = await axios.get(`/customer-orders/orders/${ordersObj.userId}`)
        if(!response.data.error){
            commit('SET_ORDERS', response.data.result)
        }
        return response.data
    },

    async fetchAddressesAction({ commit }, addressObj) { 
        commit('SET_ADDRESSES', null)
        let response = await axios.get(`/customer-addresses/addresses/${addressObj.userId}`)
        if(!response.data.error){
            commit('SET_ADDRESSES', response.data.result)
        }
        return response.data
    },
    
    async deleteAddressesAction({ dispatch }, addressObj) { 
        let response = await axios.delete(`/customer-addresses/delete-address/${addressObj.userId}/${addressObj.addressId}`)
        if(!response.data.error){
            dispatch('fetchAddressesAction', addressObj)
        }
        return response.data
    },
}

const mutations = {
    SET_ORDER: (state, setOrder) => (state.setOrder = setOrder),
    SET_ORDERS: (state, setOrders) => (state.setOrders = setOrders),
    SET_ADDRESSES: (state, setAddresses) => (state.setAddresses = setAddresses),
}

export default {
    state,
    getters,
    actions,
    mutations
}